import React, { useEffect, useState, useMemo } from "react";
import { InputField } from "./InputField";

export const InputFieldProfile = ({
  formData,
  handleChange,
  isFormDisabled = false,
  labelColor,
}) => {
  const [errors, setErrors] = useState({});

  // Static list of SE Asian countries
  const countries = [
    { value: "Brunei", label: "Brunei" },
    { value: "Cambodia", label: "Cambodia" },
    { value: "Indonesia", label: "Indonesia" },
    { value: "Malaysia", label: "Malaysia" },
    { value: "Philippines", label: "Philippines" },
    { value: "Thailand", label: "Thailand" },
    { value: "Vietnam", label: "Vietnam" },
    { value: "Myanmar", label: "Myanmar" },
  ];

  const validateField = (name, value) => {
    if ((value === undefined || value === "") && formData[name]?.required) {
      // logic handled by required prop in InputField usually, but here custom validation
    }
    // Simple verification helper, most validation is on form submit or InputField required prop
    return "";
  };

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    handleChange({ target: { name, value } });
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 my-4">
      <InputField
        label="First Name"
        name="namaDepan"
        required
        value={formData.namaDepan || ""}
        onChange={handleFieldChange}
        disabled={isFormDisabled}
        error={errors.namaDepan}
        labelColor={labelColor}
      />
      <InputField
        label="Last Name"
        name="namaBelakang"
        required
        value={formData.namaBelakang || ""}
        onChange={handleFieldChange}
        disabled={isFormDisabled}
        error={errors.namaBelakang}
        labelColor={labelColor}
      />

      <InputField
        label="Identity Number"
        name="nomorIdentitas"
        required
        value={formData.nomorIdentitas || ""}
        onChange={handleFieldChange}
        disabled={isFormDisabled}
        error={errors.nomorIdentitas}
        labelColor={labelColor}
        placeholder={
          formData.negara === "Indonesia"
            ? "Enter 16 digit ID (KTP)"
            : "Enter Passport/ID number"
        }
      />

      <InputField
        label="Date of Birth"
        name="tanggalLahir"
        type="date"
        required
        value={formData.tanggalLahir || ""}
        onChange={handleFieldChange}
        disabled={isFormDisabled}
        error={errors.tanggalLahir}
        labelColor={labelColor}
      />

      <InputField
        label="Blood Type"
        name="golonganDarah"
        type="select"
        required
        value={formData.golonganDarah || ""}
        onChange={handleFieldChange}
        disabled={isFormDisabled}
        options={[
          { value: "", label: "Select Blood Type" },
          { value: "A", label: "A" },
          { value: "B", label: "B" },
          { value: "AB", label: "AB" },
          { value: "O", label: "O" },
        ]}
        error={errors.golonganDarah}
        labelColor={labelColor}
      />

      <InputField
        label="Gender"
        name="gender"
        type="select"
        required
        value={formData.gender || ""}
        onChange={handleFieldChange}
        disabled={isFormDisabled}
        options={[
          { value: "", label: "Select Gender" },
          { value: "Male", label: "Male" },
          { value: "Female", label: "Female" },
        ]}
        error={errors.gender}
        labelColor={labelColor}
      />

      <InputField
        label="Country"
        name="negara"
        type="select"
        required
        value={formData.negara || ""}
        onChange={handleFieldChange}
        disabled={isFormDisabled}
        options={[{ value: "", label: "Select Country" }, ...countries]}
        error={errors.negara}
        labelColor={labelColor}
      />

      <InputField
        label="Official Number"
        name="kontakDarurat"
        required
        value={formData.kontakDarurat || ""}
        onChange={handleFieldChange}
        disabled={isFormDisabled}
        error={errors.kontakDarurat}
        labelColor={labelColor}
      />
    </div>
  );
};
